import { useQuery } from '@tanstack/react-query';

import { EligibleSurchargeOffersResponse } from '~/components/LERE/types';

import LereService from '~/services/LereService';

import { eligibleSurchargeOffersQueryKeys } from './eligibleSurchargeOffersQueryKeys';

export function useGetEligibleSurchargeOffers() {
  return useQuery<EligibleSurchargeOffersResponse>({
    queryKey: eligibleSurchargeOffersQueryKeys.list(),
    queryFn: async ({ signal }) => {
      return await LereService.getEligibleSurchargeOffers({ signal });
    },
    retry: false,
  });
}
